import SocialMediaLinksTab from './social-media-links';

export default SocialMediaLinksTab;
